// extracted by mini-css-extract-plugin
export var caretAnchor = "_tw-0";
export var dropdownContent = "_tw-1";